import instance from '../../config/axiosConfig';
export const UPDATE_IOU_COUNT = 'UPDATE_IOU_COUNT';

export const updateIouCount = (count) => ({
  type: UPDATE_IOU_COUNT,
  payload: count
});

export const fetchIouCount = () => {
  return async (dispatch) => {
    try {
      const { data } = await instance.get(
        `acppayvous/pending/iou?companyId=${localStorage.getItem('CompaneyId')}`
      );
      if (data && data.length > 0) {
        dispatch(updateIouCount(data.length));
      } else {
        dispatch(updateIouCount(0));
      }
    } catch (error) {
      console.log(error);
      dispatch(updateIouCount(0));
    }
  };
};
